var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M30,8H10c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V10C32,8.9,31.1,8,30,8z M28,28H12V12h16V28z M90,8H70 c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V10C92,8.9,91.1,8,90,8z M88,28H72V12h16V28z M60,8H40c-1.1,0-2,0.9-2,2v20 c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V10C62,8.9,61.1,8,60,8z M58,28H42V12h16V28z M30,38H10c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20 c1.1,0,2-0.9,2-2V40C32,38.9,31.1,38,30,38z M28,58H12V42h16V58z M90,38H70c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2 V40C92,38.9,91.1,38,90,38z M88,58H72V42h16V58z M60,38H40c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V40 C62,38.9,61.1,38,60,38z M58,58H42V42h16V58z M30,68H10c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V70 C32,68.9,31.1,68,30,68z M28,88H12V72h16V88z M90,68H70c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V70 C92,68.9,91.1,68,90,68z M88,88H72V72h16V88z M60,68H40c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V70 C62,68.9,61.1,68,60,68z M58,88H42V72h16V88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.959c3fea3caa3cbeb7c6a4cfb2448dd5.svg";
export { ForwardRef as ReactComponent };